<div
  *ngIf="showFooter === true"
  class="tw-w-full tw-h-16 tw-flex tw-justify-around tw-items-center tw-sticky tw-rounded-ss-[10px] tw-rounded-se-[10px] tw-bottom-0 tw-bg-secondary tw-px-8"
>
  <img (click)="changeScreen('orders')" class="tw-w-7 tw-h-7 tw-object-contain" [src]="ordersIcon" />
  <img (click)="changeScreen('map')" class="tw-w-7 tw-h-7 tw-object-contain" [src]="mapIcon" />
</div>
